import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "../../../common/api/apiShared";
import { Result } from "../../../common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { ISystemDeleteDialog } from "./SystemDeleteDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useSystemDeleteHook(props: ISystemDeleteDialog) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeSystemClick = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: Result<string>) => {
                props.onCloseDialog();
                if (response.success()) {
                    props.onSuccessDelete();
                    snackbar.show(createElement(Trans, { i18nKey: "systemDeleted", values: { name: props.systemName } }));
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "systemNotDeleted", values: { name: props.systemName } }), "warning");
                }
            },
        });
    };

    return {
        removeSystemClick,
        inProgress: removeMutation.isLoading,
    };

    async function remove() {
        return await deleteHttp<string>(`/system/${props.systemId}`);
    }
}
